import ActionTypes from '../constants/ActionTypes';
import api from '../constants/api';
import { authHeader } from '../helpers';
import { postApi } from '../helpers/http';

export const requestFilters = params => ({
  type: ActionTypes.REQUEST_FILTER,
  params
})

export const receiveFilters = (params, json) => ({
  type: ActionTypes.RECEIVE_FILTER,
  date: params.date,
  filters: json.filters,
  receivedAt: Date.now()
})

export const errorFilters = (error) => ({
  type: ActionTypes.ERROR_FILTER,
  error
})

const doFetchFilters = params => async dispatch => {
  dispatch(requestFilters(params))

  const data = {
    "process_type": "getDataHistoryFilters",
    "date_start": params.startDate,
    "date_end": params.endDate,
  };

  try {
    const json = await postApi(data);
    dispatch(receiveFilters(params, json.data))
  } catch (error) {
    console.error('Error:', error);
  };

  // return fetch(api.url, {
  //   method: 'POST',
  //   headers: authHeader(),
  //   body: JSON.stringify(data),
  // })
  // .then(response => response.json())
  // .then(json => {
  //   // console.log('Success:', json.data);
  //   dispatch(receiveFilters(params, json.data))
  // })
  // .catch((error) => {
  //   console.error('Error:', error);
  // });
}

export const fetchFilters = params => (dispatch, getState) => {
  return dispatch(doFetchFilters(params))
}

export const requestAppname = json => ({
  type: ActionTypes.REQUEST_APPNAME,
  json
})

export const receiveAppname = (params, json) => {
  let data;
  try {
    data = json.data;
  } catch (e) {
    console.error("Error :", e);
  }

  return {
    type: ActionTypes.RECEIVE_APPNAME,
    date: params.date,
    userNames: data?.user_name_list || [],
    departmentNames: data?.department_name_list || [],
    sectionNames: data?.section_name_list || [],
    pcNames: data?.pc_name_list || [],
    hpa27Names: data?.hpa27_list || [],
    appNames: data?.app_name_list || [],
    receivedAt: Date.now()
  }
};

const doFetchAppname = () => async (dispatch, getState) => {
  const params = { date: new Date().toISOString() };
  dispatch(requestAppname(params)); 
  const data = {
      "process_type": "getDataListFilter",
      "isGetUserNameList": true,
      "isGetDepartmentNameList": true,
      "isGetSectionNameList": true,
      "isGetPCNameList": true,
      "isGetHpa27List": true,
      "isGetAppNameList": true
  };

  try {
    const json = await postApi(data);
    dispatch(receiveAppname(params, json)); 
  } catch (error) {
    console.error('Error:', error);
  };

  // return fetch(api.url, {
  //   method: 'POST',
  //   headers: authHeader(),
  //   body: JSON.stringify(data),
  // })
  // .then(response => response.json())
  // .then(json => {
  //   dispatch(receiveAppname(params, json)); 
  // })
  // .catch((error) => {
  //   console.error('Error:', error);
  // });
}

export const fetchAppname= params => (dispatch, getState) => {
  return dispatch(doFetchAppname(params))
}


// ------------------------------------
// 各フィルターデータを取得する処理
// ------------------------------------
// フィルターデータを呼び出す状態になる
const requestFilterDatas=params=>({
  type: ActionTypes.REQUEST_FILTER_DATAS,
  // filterDatas:{},
  params
})

// フィルターデータ取得した状態になる
const receiveFilterDatas=(params,json)=>
  {
  
  return {
    type: ActionTypes.RECEIVE_FILTER_DATAS,
    date: params.date,
    // user_master: data?.user_master || [],
    // user_master_history: data?.user_master_history || [],
    // department_master: data?.department_master || [],
    // section_master: data?.section_master || [],
    // manufacturer: data?.manufacturer || [],
    // system_model: data?.system_model || [],
    // installed_app: data?.installed_app || [],
    // pc_spec: data?.pc_spec || [],
    // hpa27_version: data?.hpa27_version || [],
    filterDatas:json.data.detailData,
    receiveAt :Date.now()
  }
}

// フィルターデータが異常状態になる
export const errorFilterDatas = (error) => ({
  type: ActionTypes.ERROR_FILTER_DATAS,
  error
})

// フィルターデータを取得する処理を実行する
const doFetchFilterDatas=(params)=> async (dispatch,getState)=>{
  // const 
  params["date"]= new Date().toISOString();
  
  // ACTION状態に変更する
  dispatch(requestFilterDatas(params)); 
  const data = {
      "process_type": "getFilterDataList",
      "filter_items":params.filter_items
  };
  try {
    const json = await postApi(data);
    // データ取得した状態に変更する
    dispatch (receiveFilterDatas(params,json));
  } catch (error) {
    console.error('Error:', error);
    dispatch (errorFilterDatas(error));
  };
  // return fetch(api.url,{
  //   method: "POST",
  //   headers:authHeader(),
  //   body: JSON.stringify(data),
  // })
  // .then(response => response.json())
  // .then(json => {
  //   // データ取得した状態に変更する
  //   dispatch (receiveFilterDatas(params,json));
  // })
  // .catch ((error) => {
  //   console.error("Error", error);
  //   dispatch (errorFilterDatas(error));
  // });
}

// フィルターデータを取得する処理を呼び出す
export const fetchFilterDatas =(params) => (dispatch,getsState)=>{
  return dispatch(doFetchFilterDatas(params))
}

export const changeFilterDatas = params => (dispatch, getState) => {
  return dispatch({
    type: ActionTypes.CHANGE_FILTER_DATAS,
    filter: params
  });
}